import { call, put } from 'redux-saga/effects';

import UserClient from '../../api/UserClient';
import { userGetRequest, userUpdateSuccessful, userUpdateFailed } from '../../redux/user/actions';
import { logoutRequest } from '../../redux/login/actions';
import { messagesShow } from '../../redux/messages/actions';

export default function*({ payload }) {
    try {
        yield call(UserClient.updateUser, payload);
        yield put(userUpdateSuccessful());
        yield put(userGetRequest());
        yield put(messagesShow('editOk', 'success'));
    } catch (error) {
        if (error.code === 401) {
            yield put(logoutRequest());
        } else {
            yield put(userUpdateFailed());
            yield put(messagesShow('editNotOk', 'error'));
        }
    }
}
